<template>
    <page :busy="busy" :tabs="tabs" class="isettings-page">
        <router-view @busy="handleBusy"></router-view>
    </page>
</template>

<script>
    import Page from '../generic/page/page.vue';

    export default {
        name: 'Document',
        components: {
            Page,
        },
        computed: {
            tabs() {
                return [
                    {
                        title: 'General',
                        route: '/app/isettings/general/',
                        active: this.$route.path === `/app/isettings/general/`,
                    },
                    {
                        title: 'Bookings',
                        route: '/app/isettings/bookings/',
                        active: this.$route.path === `/app/isettings/bookings/`,
                    },
                    {
                        title: 'Localization',
                        route: '/app/isettings/localization/',
                        active: this.$route.path === `/app/isettings/localization/`,
                    },
                    {
                        title: 'Marketing',
                        route: '/app/isettings/marketing/',
                        active: this.$route.path === `/app/isettings/marketing/`,
                    },
                ];
            },
        },
        created() {
            this.$store.dispatch('iSettings/fetchSettings');
        },
        data() {
            return {
                busy: false,
            };
        },
        methods: {
            async fetchData() {
                this.handleBusy(true);
                await this.$store.dispatch('iSettings/fetchSettings');
                await this.fetchStates();
                await this.fetchProvinces();
                this.handleBusy(false);
            },
            async fetchProvinces() {
                try {
                    this.$store.dispatch('iSettings/fetchProvinces', this.selectedState);
                } catch (e) {
                    this.errorToast({ text: 'Could not fetch states' });
                }
            },
            async fetchStates() {
                try {
                    this.$store.dispatch('iSettings/fetchStates', this.selectedCountry);
                } catch (e) {
                    this.errorToast({ text: 'Could not fetch states' });
                }
            },
            handleBusy(busy) {
                this.busy = busy;
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '~bootstrap/scss/_functions.scss';
    @import '~bootstrap/scss/_variables.scss';
    @import '~bootstrap/scss/mixins/_breakpoints.scss';
    .isettings-page {
        padding: 0 15px 30px 15px;
        :deep(ul.nav) {
            margin-left: 0 !important;
            margin-bottom: 0 !important;
            .router-link-active {
                background-color: #f7f7f7 !important;
                margin-bottom: 0 !important;
                border-color: #dee2e6 #dee2e6 transparent;
            }
        }
        :deep(.lx-page-container) {
            padding: 0 15px 30px 15px;
            background-color: #f7f7f7;
            border-bottom: 1px solid #ddd;
            border-left: 1px solid #ddd;
            border-radius: 0 5px 5px 5px;
            border-right: 1px solid #ddd;
            .input-wrapper {
                background-color: #fff !important;
            }
            .form-tip {
                display: flex;
                align-items: center;
                height: 40px;
                margin-bottom: 1rem;
            }
            .thumbnail {
                display: block;
                padding: 4px;
                position: relative;
                margin-bottom: 20px;
                line-height: 1.42857143;
                background-color: #fff;
                border: 1px solid #ddd;
                border-radius: 4px;
                text-align: center;
                padding: 10px;
                -webkit-transition: border 0.2s ease-in-out;
                -o-transition: border 0.2s ease-in-out;
                transition: border 0.2s ease-in-out;
                .logo {
                    max-width: 100%;
                    padding: 15px;
                }
                .delete-icon {
                    position: absolute;
                    top: 10px;
                    right: 10px;
                    cursor: pointer;
                    &:hover {
                        color: #0d47a1;
                    }
                }
            }
            .select-language-icon {
                margin-right: 0.5rem;
                margin-bottom: 0.5rem;
                cursor: pointer;
            }

            .collapse-button {
                max-width: 200px;
                display: flex !important;
                justify-content: space-between;
                align-items: center;
            }
            .reset-button {
                width: 200px;
            }
            .smtp-settings-button {
                width: 200px;
            }
            .spf-validate {
                height: 40px;
                margin-bottom: 0.5rem;
            }
            .save-button {
                width: 100px;
            }

            .user-id-input {
                width: 25%;
            }

            .company-input {
                width: 75%;
            }

            .zip-input {
                width: 25%;
                margin-left: 0.5rem;
            }

            @include media-breakpoint-down(md) {
                .zip-input {
                    width: 100% !important;
                    margin-left: 0;
                }
                .user-id-input {
                    width: 100% !important;
                }
                .company-input {
                    width: 100% !important;
                }

                .smtp-settings-button,
                .reset-button,
                .save-button {
                    width: 100%;
                }
            }
        }
    }
</style>
